import React, { Suspense, useReducer } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import App from './App.tsx';
import { TranslationContext, AppContext } from './Context';
import './index.css';
// import * as serviceWorker from './serviceWorker'; //commented
import { ALL_ACTIONS } from './constants';
// import { unregister } from './serviceWorker';

const cacheName = 'v2';

// eslint-disable-next-line no-restricted-globals
self.addEventListener('activate', (event) => {
  // Remove old caches
  event.waitUntil(
    (async () => {
      const keys = await caches.keys();
      return keys.map(async (cache) => {
        if (cache !== cacheName) {
          console.log('Service Worker: Removing old cache: ' + cache);
          return await caches.delete(cache);
        }
      });
    })()
  );
});

const unregister = () => {
  if ('caches' in window) {
    caches.keys().then(function (keyList) {
      return Promise.all(
        keyList.map(function (key) {
          return caches.delete(key);
        })
      );
    });
  }
  if ('serviceWorker' in navigator) {
    // navigator.serviceWorker.ready.then(registration => {
    //   registration.unregister();
    // });
    navigator.serviceWorker.getRegistrations().then(function (registrations) {
      for (let registration of registrations) {
        registration.unregister();
        console.log('Changes are Loaded');
      }
    });
  }
};
// const changeMetaTagNonce = () => {
//   var unquid_id =
//     'nonce-0xf08c98caf1fd82e8cea9825dbff04fd0' +
//     Math.floor(Math.random() * 1000) +
//     new Date().getTime() +
//     '';
//   var newcontent = document
//     .getElementById('hybridMetaTag')
//     .getAttribute('content')
//     .replace('nonce-0xf08c98caf1fd82e8cea9825dbff04fd0', unquid_id);
//   document.getElementById('hybridMetaTag').setAttribute('content', newcontent);
// };

const TranslatedApp = () => {
  // changeMetaTagNonce(); //changed

  unregister();
  const { t, i18n } = useTranslation();

  window.changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <TranslationContext.Provider value={{ t, i18n }}>
      <App t={t} />
    </TranslationContext.Provider>
  );
};

const AppWrapper = () => {
  const [state, dispatch] = useReducer(reducer, {
    isLoading: false,
  });
  // changeMetaTagNonce();

  unregister();
  return (
    <AppContext.Provider value={{ ...state, dispatch }}>
      <App />
    </AppContext.Provider>
  );
};

ReactDOM.render(
  <Suspense fallback='loading'>
    {process.env.NODE_ENV === 'development' ? <AppWrapper /> : <TranslatedApp />}
  </Suspense>,
  document.getElementById('root')
);

// serviceWorker.register(); //commented

function reducer(state, action) {
  switch (action.type) {
    case ALL_ACTIONS.UPDATE_LOADER_STATE: {
      return {
        ...state,
        isLoading: action.payload,
      };
    }

    case ALL_ACTIONS.UPDATE_INPUT_STATE: {
      return {
        ...state,
        sendInput: action.payload,
      };
    }

    default: {
      return state;
    }
  }
}
